<template>
    <div class="position-box propagate">
        <div class="head" :class="{ theme: theme }">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <!-- {{$t('bzhl.title')}} -->
            <span>DeFi</span>
        </div>
        <div class="cont-box">
            <div class="head-wrap bzhl" :class="{ theme: theme }">
                <div class="info-box">
                    <div class="title">{{ $t('bzhl.zztgdzj') }}({{ currency }})</div>
                    <div class="money">{{ profitTotal.total_amount | toFixed4 }}</div>
                    <ul class="ul-box">
                        <li class="li">
                            <div class="tips">{{ $t('bzhl.yjjrsy') }}</div>
                            <div class="text">{{ profitTotal.day_profit | toFixed4 }}</div>
                        </li>
                        <li class="li">
                            <div class="tips">{{ $t('bzhl.ljsy') }}</div>
                            <div class="text">{{ profitTotal.total_profit | toFixed4 }}</div>
                        </li>
                        <li class="li">
                            <div class="tips">{{ $t('bzhl.tgzdd') }}</div>
                            <div class="text">{{ profitTotal.order_cnt }}</div>
                        </li>
                    </ul>
                    <button class="btn-jump" type="button" @click="order">{{ $t('bzhl.ckdd') }}</button>
                </div>
            </div>
            <div class="pro-wrap">
                <ul class="pro-ul">
                    <li class="pro-li">
                        <div><img class="icon" src="@/assets/bzhl/picture1.png" alt=""></div>
                        <div class="text">{{ $t('bzjj.scsq') }}</div>
                    </li>
                    <li class="pro-li">
                        <div><img class="icon" src="@/assets/bzhl/picture2.png" alt=""></div>
                        <div class="text">{{ $t('bzjj.aqbz') }}</div>
                    </li>
                    <li class="pro-li">
                        <div><img class="icon" src="@/assets/bzhl/picture3.png" alt=""></div>
                        <div class="text">{{ $t('bzjj.sybjd') }}</div>
                    </li>
                    <li class="pro-li">
                        <div><img class="icon" src="@/assets/bzhl/picture4.png" alt=""></div>
                        <div class="text">{{ $t('bzjj.mtxf') }}</div>
                    </li>
                </ul>
            </div>
            <div class="more-box" :class="{ ar: lang == 'ar' }">
                <div class="text">{{ $t('bzhlgm.cpzq') }}</div>
                <div class="rule-box" @click="selectCurrency" v-if="lang == 'ar'">
                    <img class="arrow" style="margin: 0 .3rem 0 0" src="@/assets/alb/icon_back.png" alt="">
                    <div class="rule">{{ $t('bzhl.qtbz') }}</div>
                </div>
                <div class="rule-box" @click="selectCurrency" v-else>
                    <div class="rule">{{ $t('bzhl.qtbz') }}</div>
                    <img class="arrow" src="@/assets/bzhl/jiantou_lanse.png" alt="">
                </div>
            </div>
            <ul class="item-wrap">
                <li class="list-box" v-for="(item, index) in profitList" :key="index">
                    <div class="list-head">
                        <div class="info-head">
                            <img class="icon" :src="icon" alt="">
                            <div class="text">{{ item.name }}</div>
                        </div>
                        <div class="info-foot">
                            <div class="tc">
                                <p class="t1">{{ item.rate_win }}</p>
                                <p class="t2">{{ $t("bzhlgm.rsyl") }}</p>
                            </div>
                            <div class="info-right tc">
                                <p class="t1 limit">{{ item.moneylimit }}</p>
                                <p class="t2">{{ $t('bzhl.dbxe') }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="btn" @click="buy(item.id)">{{ $t('bzhlgm.rm') }}</div>
                </li>
            </ul>
            <!-- 暂无数据 -->
            <div class="null-box" v-show="hasData">
                <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                <p class="text">{{ $t('zwsj.title') }}</p>
            </div>
        </div>
        <div class="mask" v-show="isPay"></div>
        <div class="alert-box" v-show="isPay">
            <div class="title">{{ $t('sztkmm.sztkts') }}</div>
            <div class="btn btn-bg" @click="sure">{{ $t('sztkmm.qd') }}</div>
        </div>
    </div>
</template>

<script>
let that = this;
export default {
    name: 'propagate',
    data() {
        return {
            theme: false,
            isPay: false,
            bbCount: 0.0000,
            profitTotal: {
                total_amount: '',
                day_profit: '',
                total_profit: '',
                order_cnt: ''
            },
            profitList: [],
            dbxe: '',
            rsyl: '',
            zq: '',
            qmr: '',
            service_link: '',
            currency: '',
            icondft: require('../assets/coin_type.png'),
            icon: '',
            hasData: false,
            lang: 'en'
        }
    },
    beforeCreate() {
        that = this;
    },
    created() {
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.currency = localStorage.getItem('sbsxbz') || 'USDT';
        this.icon = localStorage.getItem('sbsxIcon') || this.icondft;
        this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        this.getParams();
        this.getProfitTotal();
        this.getProfitList();
    },
    methods: {
        back() {
            this.$router.push('/index')
        },
        rule() {
            this.$router.push('/rule')
        },
        selectCurrency() {
            this.$router.push('/selectPropagateCurrency')
        },
        order() {
            this.$router.push('/orderStatus')
        },
        getParams() {
            this.$ajax.get('/web/getParam', { token: 1 }).then((res) => {
                let resData = res.data.data;
                for (var i = 0; i < resData.length; i++) {
                    if (resData[i].key == 'online_service') {
                        this.service_link = resData[i].value;
                    }
                }
            }).catch(function (err) {
                console.log(err)
            })
        },
        kefu() {
            if (!this.service_link) return;
            window.open(this.service_link)
        },
        getProfitTotal() {
            let params = {
                currency: this.currency
            }
            this.$ajax.get('/web/getProfitTotal', { params }).then((res) => {
                let resData = res.data.data;
                if (res.data.code == 1000) {
                    setTimeout(() => {
                        this.$router.push('/login');
                    }, 1000)
                    return false
                }
                this.profitTotal = resData;
            }).catch(function (err) {
                console.log(err)
            })
        },
        getProfitList() {
            let params = {
                currency: this.currency
            }
            this.$ajax.get('/web/getProfitList', { params }).then((res) => {
                let resData = res.data.data;
                this.profitList = resData.filter(item => {
                    return item.currency == this.currency
                });
                if (this.profitList.length > 0) {
                    this.hasData = false
                } else {
                    this.hasData = true
                }
            }).catch(function (err) {
                console.log(err)
            })
        },
        buy(id) {
            this.$ajax.get('/web/hasTpassword', {}).then((res) => {
                let resData = res.data.data;
                if (resData == 0) {
                    this.isPay = true;
                } else {
                    this.isPay = false;
                    this.$router.push({ path: '/propagateBuy', query: { id: id } })
                }
            }).catch(function (err) {
                console.log(err)
            })
        },
        sure() {
            this.$router.push('/setWithdrawPwd')
        }
    }
}
</script>
<style scoped>
.head {
    position: fixed;
    top: 0;
    width: 100%;
    height: 1.2rem;
    line-height: 1.2rem;
    color: #000;
    font-size: .56rem;
    background: transparent !important;
    text-align: center;
}

.head .back {
    position: absolute;
    left: .3rem;
    top: .3rem;
    width: .36rem;
    height: .72rem;
}

.head .rule {
    position: absolute;
    right: .3rem;
    color: #000;
    font-size: .42rem;
}

.head .kefu {
    position: absolute;
    right: .3rem;
    top: .3rem;
    width: .64rem;
}

.head .bg {
    position: fixed;
    right: -30px;
    top: -30px;
    z-index: -1;
    width: 3.96rem;
    opacity: .5;
    background: transparent;
}

.head.theme .bg {
    opacity: .1;
}

.head-wrap .price-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1.56rem .42rem 0;
    padding: .36rem;
    color: #fff;
    font-size: .45rem;
    background: #DDB376;
    border-radius: .15rem .15rem 0px 0px;
}

.head-wrap .price-box .price {
    display: flex;
    align-items: center;
}

.head-wrap .price-box .price .arrow {
    width: .24rem;
    margin-left: .18rem;
}

.head-wrap .info-box,
.head-wrap.theme .info-box {
    padding: .54rem .18rem .8rem;
    color: #fff;
    background: url('../assets/bzhl/kapian.png') no-repeat center center !important;
    background-size: cover;
    border-radius: .2rem;
}

.head-wrap .info-box .title {
    font-size: .4rem;
    opacity: .6;
    text-align: center;
}

.head-wrap .info-box .money {
    padding: .54rem 0;
    font-size: .8rem;
    line-height: .84rem;
    text-align: center;
}

.head-wrap .info-box .ul-box {
    display: flex;
    justify-content: space-around;
    align-items: stretch;
}

.head-wrap .info-box .ul-box .li {
    width: 33.33%;
    text-align: center;
}

.head-wrap .info-box .ul-box .tips {
    color: #fff;
    font-size: .36rem;
    opacity: .6;
}

.head-wrap .info-box .ul-box .text {
    padding-top: .48rem;
    font-size: .6rem;
}

.head-wrap .info-box .btn-jump {
    display: block;
    width: 5.68rem;
    height: 1.16rem;
    margin: .68rem auto 0;
    color: #4458ed;
    font-size: .56rem;
    background-image: linear-gradient(1deg,
            #9aa6ff 0%,
            #ffffff 100%),
        linear-gradient(#ffffff,
            #ffffff);
    background-blend-mode: normal,
        normal;
    border-radius: 0.58rem;
    text-align: center;
}

.head-wrap .info-box .btn-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: .3rem;
}

.head-wrap .info-box .btn-wrap .btn {
    width: 4.62rem;
    height: 1.02rem;
    color: #C1A372;
    font-size: .54rem;
    line-height: 1.02rem;
    background: #F3EBDC;
    border-radius: .72rem;
}

.head-wrap .info-box .btn-wrap .buy {
    color: #fff;
    background: #C68B51;
}

.cont-box {
    position: absolute;
    top: 1.2rem;
    bottom: 0;
    width: 100%;
    padding: .2rem .36rem .3rem;
    box-sizing: border-box;
    overflow-y: scroll;
}

.pro-wrap .pro-box {
    padding: .75rem 0 .45rem;
    font-size: .54rem;
}

.pro-wrap .pro-ul {
    display: flex;
    justify-content: space-around;
    align-items: stretch;
    padding: .6rem 0 .7rem;
    border-radius: .15rem;
    background: transparent !important;
}

.pro-wrap .pro-ul .pro-li {
    width: 25%;
    text-align: center;
}

.pro-wrap .pro-ul .pro-li .icon {
    height: .68rem;
}

.pro-wrap .pro-ul .pro-li .text {
    padding-top: .24rem;
    font-size: .36rem;
}

.more-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 .45rem;
    font-size: .48rem;
}

.more-box .more {
    color: #656565;
    font-size: .36rem;
}

.more-box .rule-box {
    position: absolute;
    right: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: auto;
    height: 1rem;
    padding: 0 .3rem 0 .7rem;
    background: #dcdff6;
    border-radius: 0.5rem 0 0 0.5rem;
    box-sizing: border-box;
}

.more-box.ar .rule-box {
    left: .36rem;
    right: auto;
}

.more-box .rule-box .rule {
    color: #4458ed;
    font-size: .39rem;
    white-space: nowrap;
}

.more-box .rule-box .arrow {
    height: .32rem;
    margin-left: .3rem;
}

.cont-box .list-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .3rem;
    padding: .45rem .2rem;
    background: #fff;
    border-radius: .1rem;
}

.cont-box .list-box .info-head {
    display: flex;
    align-items: center;
}

.cont-box .list-box .list-head {
    flex: 1;
}

.cont-box .list-box .list-head .info-foot {
    display: flex;
    align-items: center;
}

.cont-box .list-box .list-head .info-foot {
    margin-top: .36rem;
}

.cont-box .list-box .list-head .info-foot .t2 {
    padding-top: .24rem;
    color: #646464;
    font-size: .36rem;
}

.cont-box .list-box .list-head .info-foot .t1 {
    color: #4458ed;
    font-size: .42rem;
    font-weight: bold;
}

.cont-box .list-box .list-head .info-foot .limit {
    color: #000;
}

.cont-box .list-box .list-head .info-right {
    margin-left: .6rem;
}

.cont-box .list-box .icon {
    width: .84rem;
    height: .84rem;
    margin-right: .3rem;
    border-right: 50%;
}

.cont-box .list-box .text {
    flex: 1;
    font-weight: bold;
}

.cont-box .list-box .btn {
    width: 2.16rem;
    padding: .18rem 0;
    color: #fff;
    font-size: .26rem;
    background: #4458ed;
    border-radius: .4rem;
    text-align: center;
}

.alert-box {
    position: fixed;
    top: 50%;
    left: .45rem;
    right: .45rem;
    z-index: 1000;
    width: auto;
    padding: .48rem;
    background: #fff;
    border-radius: .24rem;
    transform: translateY(-50%);
}

.alert-box .title {
    color: #000;
    font-size: .38rem;
}

.alert-box .btn {
    width: 100%;
    margin-top: .6rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/propagate.vue